class LoadBee {
    constructor (element) {
        this.$loadBee = element;
    }

    initialize () {
        this.checkLoadBee();
    }

    checkLoadBee () {
        const loadbeeURL = this.$loadBee.getAttribute('data-loadbee-script-url');

        setTimeout(() => {
            const script = document.createElement('script');
            script.src = loadbeeURL;
            script.addEventListener('load', () => {
                setTimeout(() => {
                    if (!document.querySelector('[data-loadbee-script-url] iframe')) {
                        document.querySelector('[href="#herstellerinformationen"]').closest('li').remove();
                    } else {
                        document.querySelector('[href="#herstellerinformationen"]').closest('li').classList.remove('is--notactive');
                    }
                }, 2000);
            });
            document.body.appendChild(script);
        }, 500);
    }
}

export { LoadBee };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$loadBee = $context.querySelectorAll('[data-loadbee-script-url]');
        for (let i = 0; i < $$loadBee.length; i++) {
            const $loadBee = new LoadBee($$loadBee[i]);
            $loadBee.initialize();
        }
    }
});
